import React from 'react'
import UiSelectPicker from './UiSelectPicker';

interface UiInputTagsProps {
    name: string;
    label?: string;
    size?: number;
    tipo?: number; // 1=Financeiro, 2=Orçamento
    allowCreate?: boolean;
}

export default function UiInputTags({ name, label = 'Tags', size = 12, tipo = 1, allowCreate = true }: UiInputTagsProps) {
    return (
        <UiSelectPicker
            size={size}
            name={name}
            label={label}
            router="tag"
            idField="id"
            titleField="titulo"
            allowCreate={allowCreate}
            extraDataOnCreate={{ tipo }}
            extraDataOnFilter={{
                name: 'tipo',
                v: String(tipo),
                v2: null,
                op: 'like'
            }}
        />
    );
}
